import * as React from "react";
import {
    Theme,
    makeStyles,
    Container,
    Typography,
    Link
} from "@material-ui/core";
import CustomizedDialogs from "../../feedback/FeedbackDialog";
import { useAuth } from "../../../services/authentication";

const useStyles = makeStyles((theme: Theme) => ({
    helpBar: {
        backgroundColor: theme.palette.primary.main,
        padding: theme.spacing(7, 0),
        color: theme.palette.primary.contrastText
    }
}));

export const Banner: React.FC = ({ children }) => {
    const classes = useStyles();

    return (
        <section className={classes.helpBar}>
            <Container maxWidth="lg">{children}</Container>
        </section>
    );
};

export interface TextBannerProps {
    text: string;
}

export const TextBanner: React.FC<TextBannerProps> = props => {
    return (
        <Banner>
            <Typography variant="h4" align="center">
                {props.text}
            </Typography>
        </Banner>
    );
};

const HelpBar: React.FC = () => {
    const { authState } = useAuth();

    return (
        <Banner>
            <Typography variant="h4" align="center">
                Need help?&nbsp;
                <Link
                    color="inherit"
                    href="mailto:tracerco.software@tracerco.com"
                    underline="always"
                >
                    Get in touch
                </Link>
                &nbsp;with us
                {authState?.loggedIn ? (
                    <>
                        {" "}
                        |&nbsp;Please leave us&nbsp;
                        <CustomizedDialogs />
                    </>
                ) : (
                    <> </>
                )}
            </Typography>
        </Banner>
    );
};

export default HelpBar;
